import { useQuery } from 'react-query';
import { dsoCheckoutService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetrieveDsoBillingAddresses = () => {
  return useQuery(
    [ServerStateKeysEnum.dsoBillingAddresses],
    () => {
      return dsoCheckoutService.getBillingAddresses();
    },
    {
      staleTime: Infinity,
      refetchOnMount: 'always',
    }
  );
};
